import React from "react";
import { useTheme } from "../../providers/ThemeContext";
import { ReactComponent as LightSvg } from "../../assets/logo/creation-arts-icon-mark.svg";
import { ReactComponent as DarkLogo } from "../../assets/logo/creation-arts-white-icon-mark.svg";

type Props = {
  size?: number;
  color?: string;
  title?: string;
  className?: string;
  /** Always use the light-background mark (e.g. on a cream header in dark mode). */
  forceLight?: boolean;
};

const BrandMark: React.FC<Props> = ({
  size = 28,
  color,
  title = "Creation Arts mark",
  className,
  forceLight = false,
}) => {
  const { theme, isDark: themeDark } = useTheme();
  const isDark = themeDark && !forceLight;

  const style: React.CSSProperties = {
    display: "inline-block",
    color: color ?? theme.text,
    width: size,
    height: size,
  };

  return isDark ? (
    <DarkLogo
      style={style}
      className={className}
      aria-label={title}
      role="img"
    />
  ) : (
    <LightSvg
      style={style}
      className={className}
      aria-label={title}
      role="img"
    />
  );
};

export default BrandMark;
